import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Select, Flex } from '@mantine/core'
import { AreaChart } from '@mantine/charts'
import { getDataStatsTotalOrder } from '../../../services/dashboard'
import classes from '../../../assets/module-css/AdminLayout.module.css'

const defaultRangeStats = [
  {
    label: 'Daily',
    value: 'DAILY'
  },
  {
    label: 'Weekly',
    value: 'WEEKLY'
  },
  {
    label: 'Monthly',
    value: 'MONTHLY'
  },
]

const defaultOrderStatus = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'Finished',
    value: 'FINISHED'
  },
]

const DashboardStatsTotalOrder = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsOrderTotal, setStatsOrderTotal] = useState([])
  const [selectedRange, setSelectedRange] = useState('DAILY')
  const [selectedStatus, setSelectedStatus] = useState('ALL')

  const handleGetStatsTotalOrder = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsTotalOrder(selectedStatus, selectedRange)
      if (response?.data) {
        const responseStats = response.data.orderStats
        setStatsOrderTotal(responseStats)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsTotalOrder()
    // eslint-disable-next-line
  }, [selectedStatus, selectedRange])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={120}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    return (
      <Box>
        <AreaChart
          h={250}
          data={statsOrderTotal}
          dataKey='label'
          series={[
            {
              name: 'count',
              label: 'Total Order',
              color: 'red'
            }
          ]}
          curveType="natural"
          tickLine="xy"
          gridAxis="xy"
        />
      </Box>
    )
  }


  return (
    <Paper shadow="sm" p='md' withBorder radius='md' my='lg'>
      <Text className={classes.titleLayout} mb='md'>Total Order Frequency</Text>
      <Flex gap='md' align='center'>
        <Box>
          <Select
            name='selectedRange'
            label="Based on Period"
            value={selectedRange}
            data={defaultRangeStats}
            onChange={setSelectedRange}
            size='xs'
            allowDeselect={false}
            w={150}
          />
        </Box>
        <Box>
          <Select
            name='selectedStatus'
            label="Order Status"
            value={selectedStatus}
            data={defaultOrderStatus}
            onChange={setSelectedStatus}
            size='xs'
            allowDeselect={false}
            w={180}
          />
        </Box>
      </Flex>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatsTotalOrder